import { FC, ReactNode, useState } from "react";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import { LayoutWrapper } from "./Layout.style";
import { Appbar, Footer, Sidebar, MobileSidebar } from "components";

type ILayoutProps = {
  children: ReactNode;
};

export const Layout: FC<ILayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [search, setSearch] = useState<string>("");

  return (
    <LayoutWrapper>
      <Appbar />
      <Grid className="main-container">
        {isMobile ? (
          <MobileSidebar setSearch={setSearch} search={search} />
        ) : (
          <Sidebar setSearch={setSearch} search={search} />
        )}
        <Box component="main" className="main-content">
          {children}
        </Box>
      </Grid>
      <Footer />
    </LayoutWrapper>
  );
};
